<!-- 首页导航 -->
<template>
  <div class='home-menu'>
    <div>
      <img :src='logo'
           alt="再来人Logo"
           calss="logo"
           width="160px"
           @click="handleHome"
           class="logo">
      <ul class="home-menu-list">
        <li v-for="(item,index) in menuList"
            :key="index">
          <router-link :to="item.path">{{item.title}}</router-link>
        </li>
      </ul>
      <div class="home-menu-right">
        <div class="home-menu-remind">
          <zlr-remind></zlr-remind>
        </div>
        <div class="home-menu-avator">
          <zlr-personal></zlr-personal>
          <!-- <img :src="logo"
               alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/Logo.svg'
// components
import ZlrRemind from '_c/remind/remind'
import ZlrPersonal from '_c/dropdown/dropdown'
import { infoQueryDetail } from '@/api/info'
export default {
  name: 'home-menu',
  components: {
    ZlrRemind,
    ZlrPersonal
  },
  data () {
    return {
      logo,
      menuList: [
        {
          title: '申请信息',
          path: '/application'
        },
        {
          title: '服务团队',
          path: '/team'
        },
        {
          title: '导师辅导',
          path: '/mentor'
        },
        {
          title: '学校选择',
          path: '/choose'
        },
        {
          title: '项目申请',
          path: '/project'
        },
        {
          title: '简历 / 推荐信',
          path: '/cv-rl'
        },
        {
          title: '须知文档',
          path: '/documents'
        },
        {
          title: '视频资料',
          path: '/video-course'
        }
      ]
    }
  },
  computed: {},
  mounted () {
    this.$store.dispatch('getInfoDetail')
    this.deleteMenuMaterial()
    // 我的规划菜单
    this.getMyplanMenu()
  },
  methods: {
    handleHome () {
      this.$router.push({
        name: 'home'
      })
    },
    deleteMenuMaterial () {
      let ids = [123, 124, 125, 126, 127]
      infoQueryDetail({}).then(res => {
        let model = res.data.model
        if (model.packageId && ids.includes(model.packageId)) {
          this.menuList.pop()
        }
      })
    },
    getMyplanMenu () {
      let isMyplan = localStorage.getItem('isMyplanShowMenu')
      if (isMyplan !== '' && isMyplan !== 'null' && isMyplan !== null && isMyplan !== undefined) {
        this.menuList.unshift({
          title: '我的规划',
          path: '/myplan'
        })
      }
      // localStorage.removeItem('isMyplanShowMenu')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
